const _valueOf = (value) => (value && Array.isArray(value) ? value.length : 0)

export default {
  type: 'M',
  render: _valueOf,
  compare: (a, b) => _valueOf(a) - _valueOf(b)
}
